import { Box, Stack, styled } from '@mui/material';

export const StyledOuterContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
  minHeight: '100dvh',
}));

export const Container = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1),
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(22),
}));

export const StyledFooter = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  backgroundColor: theme.palette.grey[900],
}));

export const FormulaFieldsSwitchContainer = styled(Box)(({ theme }) => ({
  overflowX: 'hidden',
  padding: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  borderWidth: 1,
  borderTopStyle: 'solid',
  borderBottomStyle: 'solid',
  borderColor: theme.palette.grey[700],
  backgroundColor: theme.palette.grey[900],
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[900],
}));
